export const BANNER_MOBILE_WIDTH = 768
export const BANNER_MOBILE_BREAKPOINTS = [375, 480, 640, 768]
export const BANNER_MOBILE_SIZES = '100vw'

export const BANNER_DESKTOP_WIDTH = 1200
export const BANNER_DESKTOP_BREAKPOINTS = [768, 960, 1200]
export const BANNER_DESKTOP_SIZES = '(max-width: 991px) 58vw, 1000px'

export const BANNER_IMAGE_SIZES =
  '(max-width: 767px) 100vw, (max-width: 991px) 58vw, 1000px'

// Match the variant a 412px phone at 2x DPR will select from the mobile srcset.
export const BANNER_MOBILE_PRELOAD_TARGET_WIDTH = 768

export const BANNER_MOBILE_MEDIA = '(max-width: 767px)'
export const BANNER_DESKTOP_MEDIA = '(min-width: 768px)'

export const BANNER_LCP_FORMAT = 'image/avif'
